import { useContext } from 'react';

import UserContext from '../user-context';

export const useUserFilters = () => {
  const { user } = useContext(UserContext);

  return user?.settings?.filters ?? null;
};
